import * as React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import toast from 'cogo-toast';
import dayjs from 'dayjs';
import {
  Page,
  Grid,
  Card,
  Button,
  Icon,
  Header,
  Text,
  Dropdown,
} from 'tabler-react';
import ShareModal from './ShareModal';
import TrialCards from './TrialCards';
import VasCards from './VasCards';

import Request from '../../shared/request';
import Modal from '../../components/Modal';
import PageComponent from '../PageComponent';
import store from '../../shared/store';
import cardEmpty from '../../assets/card_empty.png';
import './home.scss';

const CARDS = {
  PROMOCODE: {
    name: '优惠券',
    tip: '查看使用规则',
    rules: ['可以在购买时使用抵扣金额', '请注意过期时间'],
  },
  PROMO: {
    name: '邀请卡',
    tip: '朋友激活，双方获得时长',
    rules: ['VIP不可使用', '每人只能使用一张', '每激活一张将获得同等时长'],
  },
  SALE: {
    name: '充值卡',
    tip: '查看使用规则',
    rules: ['任何人都可以使用', '请在过期前使用掉'],
  },
};

const ConfirmEmail = props => {
  if (store.user.needBindEmail) {
    return (
      <Grid.Row>
        <Grid.Col sm={12}>
          <div className="malus-tip email-confirm-tip">
            <span>为确保在其他客户端正常登录使用、请先绑定邮箱账号</span>
            <Link to="/dashboard/bind-email">
              <Button color="danger" size="sm">
                立即绑定
              </Button>
            </Link>
          </div>
        </Grid.Col>
      </Grid.Row>
    );
  }
  if (store.user.needSetPassword) {
    return (
      <Grid.Row>
        <Grid.Col sm={12}>
          <div className="malus-tip email-confirm-tip">
            <span>为确保在其他客户端正常登录使用，请先设置密码</span>
            <Link to="/dashboard/set-password">
              <Button color="danger" size="sm">
                立即设置密码
              </Button>
            </Link>
          </div>
        </Grid.Col>
      </Grid.Row>
    );
  }
  if (props.status === 'UNCONFIRM') {
    return (
      <Grid.Row>
        <Grid.Col sm={12}>
          <div className="malus-tip email-confirm-tip">
          <span>未确认邮箱无法找回密码会影响使用，请确认邮箱</span>
            <Link to="/dashboard/email">
              <Button color="danger" size="sm">
                立即认证邮箱
              </Button>
            </Link>
          </div>
        </Grid.Col>
      </Grid.Row>
    );
  }
  return <></>;
};

class Home extends PageComponent {
  state = {
    notifications: [],
    cards: null,
    referStats: null,
    referLink: null,
    shareText: null,
    isOpen: false,
  };

  showModal = () => {
    const shareModal = (
      <ShareModal
        referLink={this.state.referLink}
        shareText={this.state.shareText}
        referStats={this.state.referStats}
      />
    );
    Modal(shareModal, { title: '邀请好友注册' });
  };

  componentWillMount() {
    if (window.location.href.includes('referral')) {
      this.setState({ showReferral: true });
    }
  }

  async componentDidMount() {
    try {
      const objectSearch = new URLSearchParams(window.location.search);
      const message = objectSearch.get('message');
      if (message) {
        toast.info(message);
      }
    } catch (err) {
      // noop
    }
    await store.dispatch({ type: 'updateUser' });
    const { showReferral } = this.state;

    const cards = await Request.call('getCards');
    this.setState({ cards });
    // const pointsStatus = await Request.call('getPointsStatus');
    // this.setState({ pointsStatus });
    const res = await Request.call('getReferStats');
    if (res) {
      const referLink = `https://miaovpn.com/start/${res.referCode}`;
      this.setState({
        referStats: res.data,
        referLink,
        shareText: `推荐一款海外回国加速器 - 加速喵，看视频听音乐、做直播、打游戏全支持。${referLink} 用我分享的链接注册就可获得VIP`,
      });

      if (showReferral) {
        this.showModal();
      }
    }
  }

  showTrialCards = () => {
    const trialCards = (
      <TrialCards
        referLink={this.state.referLink}
        shareText={[
          this.state.shareText,
          `。登录后即可兑换，还有${this.getTrialCards().length}张体验卡：\n`,
          this.getTrialCards()
            .map(card => card.code)
            .join('\n'),
        ].join('')}
      />
    );
    Modal(trialCards, {
      title: '可用体验卡（好友激活多少返多少）',
    });
  };

  trialDesc = () => {
    if (this.trialPlanId === 'TURBO') {
      return `标准体验 ${dayjs(store.user.trialExpiredAt).format(
        'YYYY.MM.DD',
      )}`;
    }
    return `高级会员体验 ${dayjs(store.user.trialExpiredAt).format('YYYY.MM.DD')}`;
  };

  render() {
    if (
      window.location.pathname.split('/').pop() === 'referral' &&
      !this.state.isOpen
    ) {
      return <Redirect to="/dashboard" />;
    }

    const { referStats } = this.state;

    return (
      <Page.Content>
        <ConfirmEmail status={store.user.status} />

        <Grid.Row cards>
          <Grid.Col xl={6} lg={6} md={12} sm={12} xs={12}>
            <Card className="stats-card">
              <div className="stats-icon">
                <i className="fad fa-user-astronaut"></i>
              </div>
              <div className="stats-detail">
                <span>当前会员状态</span>
                <div className="stats-member">
                  <span>{store.user.userDesc}</span>
                  <span>
                    {store.user.planExpiredAt > 0
                      ? dayjs(store.user.planExpiredAt).format('YYYY.MM.DD')
                      : ''}
                  </span>
                </div>
                {store.user.isTrial ? (
                  <div className="invite-tips game-trial">
                    <Icon name="zap" />
                    <span>{this.trialDesc()}</span>
                  </div>
                ) : (
                    ''
                  )}
              </div>
              <a
                href="/buy?utm_source=dashboard&utm_medium=status"
                target="noopener noreferrer">
                <Button pill color="primary" size="sm">
                  {store.user.userType !== 'FREE' ? '续费VIP' : '购买VIP'}
                </Button>
              </a>
            </Card>
          </Grid.Col>
          <Grid.Col xl={6} lg={6} md={12} sm={12} xs={12}>
            <Card className="stats-card">
              <div className="stats-icon stats-icon-user">
                <i className="fad fa-share"></i>
              </div>
              <div className="stats-detail">
                <span>已邀请人数</span>
                <div className="stats-member">
                  <span>
                    {(referStats && referStats.referCount) || 0}
                  </span>
                </div>
                {this.getInviteButton()}
              </div>

              <div className="invite-tips">
                邀请好友注册加速喵,各获 3 天标准会员
              </div>
            </Card>
          </Grid.Col>
        </Grid.Row>

        <Grid.Row cards>
          <Grid.Col xl={6} lg={6} md={12} sm={12} xs={12}>
            <Card className="vip-center">
              <Card.Header>
                <Card.Title>会员权益</Card.Title>
              </Card.Header>
              <Card.Body className="vas-body">
                <VasCards {...this.props} />
              </Card.Body>
            </Card>
          </Grid.Col>

          <Grid.Col xl={6} lg={6} md={12} sm={12} xs={12}>
            <Card className="act-center">
              <Card.Header>
                <Card.Title>卡券中心</Card.Title>
              </Card.Header>
              <Card.Body>{this.getCards()}</Card.Body>
            </Card>
          </Grid.Col>
        </Grid.Row>
      </Page.Content>
    );
  }

  getCards() {
    const { cards: realCards } = this.state;
    const cards = realCards ? [...realCards] : [];
    if (store.user.isEdu) {
      cards.push({
        id: null,
        code: 'EDUCATION',
        type: 'PROMOCODE',
        days: 0,
        promoCode: { off: '30' },
        expiredAt: 0,
      });
    }

    if (!cards) {
      return (
        <Grid.Row>
          <Grid.Col>
            <Card>
              <Card.Body>
                <Text align="center">Loading...</Text>
              </Card.Body>
            </Card>
          </Grid.Col>
        </Grid.Row>
      );
    }

    if (!cards.length) {
      return (
        <Grid.Row>
          <Grid.Col>
            <Card>
              <Card.Body>
                <div className="card-empty">
                  <img src={cardEmpty} alt="empty-icon" />
                  <Text align="center">喵~暂无卡券</Text>
                </div>
              </Card.Body>
            </Card>
          </Grid.Col>
        </Grid.Row>
      );
    }

    return cards.map(card => {
      switch (card.type) {
        case 'SALE':
        case 'PROMO':
          return (
            <Card.Body className={`ac-card ac-card-${card.type.toLowerCase()}`}>
              <div className="ac-card-left ac-card-left-promo">
                <div className="top">
                  <h3>{(card.promo || card.sale).days}</h3>
                  <small>天</small>
                </div>
                <span className="card-type">{CARDS[card.type].name}</span>
              </div>
              <div className="ac-card-right">
                <div className="top">
                  <span className="card-code" id={`card_${card.code}`}>
                    {card.code}
                    <CopyToClipboard
                      text={card.code}
                      onCopy={() => toast.success('复制成功')}>
                      <Button icon="clipboard" size="sm" />
                    </CopyToClipboard>
                  </span>
                </div>
                <div className="bottom">
                  <span>
                    {card.expiredAt
                      ? `${dayjs(card.expiredAt).format('YYYY-MM-DD')} 到期`
                      : '永久有效'}
                  </span>
                  {card.type === 'PROMO' ? (
                    <Button
                      color="orange"
                      size="sm"
                      onClick={this.showTrialCards}>
                      立即分享
                    </Button>
                  ) : (
                      <Button
                        color="orange"
                        size="sm"
                        onClick={() => window.open(`/active?code=${card.code}`)}>
                        立即使用
                      </Button>
                    )}
                </div>
                <div className="card-info">
                  <Dropdown
                    triggerContent={CARDS[card.type].tip}
                    arrow
                    itemsObject={CARDS[card.type].rules.map(value => ({
                      value,
                    }))}
                  />
                  <Icon name="chevron-right" />
                </div>
              </div>
            </Card.Body>
          );
        case 'PROMOCODE':
          return (
            <Card.Body className="ac-card">
              <div className="ac-card-left">
                <div className="top">
                  <h3>{card.promoCode.off}%</h3>
                  <small>折扣</small>
                </div>
                <span className="card-type">{CARDS[card.type].name}</span>
              </div>
              <div className="ac-card-right">
                <div className="top">
                  <span className="card-code">
                    {card.code}
                    <CopyToClipboard
                      text={card.code}
                      onCopy={() => toast.success('复制成功')}>
                      <Button icon="clipboard" size="sm" />
                    </CopyToClipboard>
                  </span>
                </div>
                <div className="bottom">
                  <span>
                    {card.expiredAt
                      ? `${dayjs(card.expiredAt).format('YYYY-MM-DD')} 到期`
                      : '永久有效'}
                  </span>
                  <Button
                    RootComponent="a"
                    href={`/buy?code=${card.code
                      }&utm_source=dashboard&utm_medium=card`}
                    color="success"
                    size="sm"
                    target="noopener noreferrer">
                    立即使用
                  </Button>
                </div>
                <div className="card-info">
                  <Dropdown
                    triggerContent={CARDS[card.type].tip}
                    arrow
                    itemsObject={CARDS[card.type].rules.map(value => ({
                      value,
                    }))}
                  />
                  <Icon name="chevron-right" />
                </div>
              </div>
            </Card.Body>
          );
        default:
          return null;
      }
    });
  }

  getInviteButton() {
    const { referStats } = this.state;
    const { user } = store;
    return user.status === 'UNCONFIRM' ? (
      <div className="refer-days disabled">
        <i className="ri-information-line" />
        确认邮箱后邀请才能生效
      </div>
    ) : (
        <Button pill color="info" outline size="sm" onClick={this.showModal}>
          邀请好友，已获得
          {((referStats && referStats.referCount) || 0) * 3}天
        </Button>
      );
  }

  getTrialCards() {
    const { cards } = this.state;
    if (!cards) return [];
    return cards.filter(card => card.type === 'PROMO');
  }
}

export default Home;
